import { render, staticRenderFns } from "./pointFestival.vue?vue&type=template&id=6c087254&scoped=true"
import script from "./pointFestival.vue?vue&type=script&lang=js"
export * from "./pointFestival.vue?vue&type=script&lang=js"
import style0 from "./pointFestival.vue?vue&type=style&index=0&id=6c087254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c087254",
  null
  
)

export default component.exports